











































import { Component, mixins, Prop, Vue, Watch } from 'nuxt-property-decorator'
import { mdiClose, mdiMagnify } from '@mdi/js'
import vClickOutside from 'v-click-outside'
import { ISearchSuggest } from '~/assets/interfaces/search'
import { debounce } from '~/assets/functions/debounce'
import { SEARCH_PATH } from '~/assets/config/path'
import { SEARCH_API } from '~/assets/config/api-path'
import { filterUrl } from '~/assets/filters/url'
import MixinGeneral from '~/assets/mixins/general'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'

Vue.use(vClickOutside)

@Component({
  components: {
    ComponentIcon,
    ComponentFormButtonIcon,
    componentHeaderQuickSearchSuggests: () =>
      import('~/components/search/quick-search-suggests.vue'),
  },
})
export default class componentHeaderQuickSearch extends mixins(MixinGeneral) {
  @Prop({ type: Boolean, default: true }) readonly border!: boolean
  @Prop({ type: String }) readonly background!: string
  @Prop({ type: Boolean, default: false }) private inverse!: boolean

  private mdiMagnify = mdiMagnify
  private mdiClose = mdiClose
  private searchText = ''
  private suggestions: ISearchSuggest[] = []

  private isLoading = false

  @Watch('$route')
  private onRouteChange() {
    this.searchText = ''
    this.suggestions = []
  }

  @Watch('searchText')
  private searchTextHandler(query: string) {
    this.searchQuickDebounce(query, this)
  }

  private clearSearchText() {
    this.searchText = ''
  }

  private clickOutsideHandler() {
    this.clickOutside = true
  }

  private clickInsideHandler() {
    this.clickOutside = false
  }

  private get isShowSuggest() {
    return this.suggestions.length > 0 && !this.clickOutside
  }

  private clickOutside = true
  private searchQuickDebounce: (query: string, that: this) => void = debounce(
    (query: string, that: this) => {
      that.getItems(query)
    },
    250
  )

  private async getItems(query: string) {
    if (query.trim().length > 0) {
      this.isLoading = true

      const response = await this.$axios.$get(filterUrl(SEARCH_API), {
        params: {
          query: query.trim(),
        },
      })

      this.suggestions = response.suggestions
      this.isLoading = false
    }
  }

  private submitHandler(e: Event) {
    e.preventDefault()
    if (this.searchText.trim().length > 0) {
      this.$router.push({
        path: filterUrl(SEARCH_PATH),
        query: { query: this.searchText },
      })
    }
  }
}
